import register from '@kpsys/angularjs-register';
import KpLocalizationsComponent from './kp-localizations.component';
import localizationRoutes from './localizations.routes';


export default register('portaro.localizations')
    .config(localizationRoutes)
    .component(KpLocalizationsComponent.componentName, KpLocalizationsComponent)
    .name();